import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { icons } from 'src/app/shared-data/common-arrays';
import {MatDialog as MatDialog } from '@angular/material/dialog';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { RolesDialogeComponent } from '../../roles-dialoge/roles-dialoge.component';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { SharedService } from 'src/app/services/shared.service';
import { Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-childs-menu',
  templateUrl: './childs-menu.component.html',
  styleUrls: ['./childs-menu.component.css']
})
export class ChildsMenuComponent implements OnInit, OnDestroy {

  @ViewChild('addEditTemplate', {static:true}) addEditTemplate: ModalDirective;

  @Input() childs;
  @Input() parentMenus;
  @Input() isParentChecked;
  @Input() data;

  @Output() addChildMenu = new EventEmitter();
  @Output() editChildMenu = new EventEmitter();
  @Output() refresh = new EventEmitter();

  allPages: any[];
  pages: any[];
  searchText = "";
  filterText = ""
  tempMenu: any = {};

  icons: any[] = icons
  parent: any[];
  menuToEditIndex: any;
  selectedMenus: any[] = [];
  @Output() pushPublishChild = new EventEmitter();
  @Output() splicePublishChild = new EventEmitter();
  @Input() showCheckbox;


  constructor(private httpClient: HttpClient,
    private dialog: MatDialog,  private snotifyService: ToastrService,
    private _snackBar: MatSnackBar,
    private sharedService: SharedService,) {
      
     }


  ngOnInit() {
  
   }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyWarning(message: string) {
    this.snotifyService.warning(message,"", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  addMenu(menu) {
    menu = JSON.parse(JSON.stringify(this.data));
    this.addChildMenu.emit(menu);
    this.tempMenu = {};
  }

  editMenu(menu) {
    console.log('menu',menu)
    menu.externalSlug=menu.slug
    this.editChildMenu.emit(menu);
    this.tempMenu = {};
  }

  deleteMenu(menu) {
    this.httpClient.post('/Menus/DeleteMenu/' + menu.id, {}).subscribe((res: any) => {
      this.refresh.emit(menu.categoriesId);
      this.openNotifySuccess('Menu deleted successfuly');
    });
  }

  publicUnpublish(menu, status) {
    menu.status = status;
    this.httpClient.post('/Menus/EditMenu/' + menu.id, menu).subscribe((res: any) => {
      if (status == 1) {
        this.openNotifyWarning('Menu Unpublished successfuly');
      } else {
        this.openNotifySuccess('Menu published successfuly');
      }
      this.refresh.emit(menu.categoriesId);

    });


  }


  refreshMenu($event) {
    this.refresh.emit($event);
  }

  securityDialog(menu) {
    this.httpClient.get(`/Menus/GetMenuAssignedRoles/${menu.id}`).subscribe((res: any) => {
      let dialogRef = this.dialog.open(RolesDialogeComponent, { width: '70vw', data: { unAssigendRole: res.unassingedRoles, assigendRoles: res.assingedRoles } });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          let rolesAndAsigend: any = {
            'id': menu.id,
            'unassingedRoles': result.unAssigendRole,
            'assingedRoles': result.assigendRoles
          }
          this.httpClient.post('/Menus/SaveMenuAssginedRoles', rolesAndAsigend).subscribe((res: any) => {
            this.openNotifySuccess('Assigend Successfully')
          });
        }
      });
    })
  }

  isProhibtedHandler(item: any, index, destinationMenu, childElement?) {
    let result = false;
    if (childElement) {
      if (childElement.id === item.dragData.parent.parentId) {
        return true;
      }
      else if ((item.dragData.parent.parentId === this.childs[index].parentId) && (item.dragData.parent.id === this.childs[index].id)) {
        return true;
      } else if (item.dragData.parent.id == destinationMenu.parentId) {
        return true;
      }
    } else if (destinationMenu.childs.length > 0 && ((item.dragData.parent.parentId === this.childs[index].parentId) && (item.dragData.parent.id === this.childs[index].id))) {
      return true;
    } else if (item.dragData.parent.id === this.childs[index].parentId) {
      return true;
    }

    if (item.dragData.parent.childs) {
      result = this.checkChilds(item.dragData.parent, destinationMenu);
    }
    return result;
  }

  checkChilds(item, destinationItem) {
    let result = false;
    if (!item.childs || item.childs.length == 0)
      return result;
    var recursiveItem = item.childs.find(x => x.id === destinationItem.id || x.id === destinationItem.parentId);
    if (recursiveItem != null) {
      result = true;
    } else {
      item.childs.forEach(childItem => {
        if (childItem.childs && childItem.childs.length > 0) {
          result = this.checkChilds(childItem, destinationItem);
        }
      });
    }
    return result;
  }

  getNewOrder(destinationMenu): number {
    let newOrder: number;
    if (destinationMenu.childs.length > 0) {
      var maxOrder = destinationMenu.childs[destinationMenu.childs.length - 1].order;
      newOrder = Number(maxOrder) + 1;
    } else {
      newOrder = 1;
    }
    return newOrder;
  }

  moveMenuChild(item: any, index, destinationMenu) {
    if ((item.dragData.parent.parentId === this.childs[index].parentId) && (item.dragData.parent.id === this.childs[index].id)) {
      return
    }
    let isProhibted = this.isProhibtedHandler(item, index, destinationMenu);

    if (!isProhibted) {
      let newOrder = this.getNewOrder(destinationMenu);
      let data = {
        'sourceParentId': (item.dragData.parent.parentId) ? item.dragData.parent.parentId : 0,
        'sourceID': item.dragData.parent.id,
        'destinationParentId': (this.childs[index].parentId) ? this.childs[index].parentId : 0,
        'destinationID': this.childs[index].id,
        'newOrder': newOrder,
        'type': 'add'
      };
      this.AddSwapChildMenu(data, item);
    } else {
      this.openSnackBar("Prohibited scope");
    }
  }

  moveMenu(item: any, index, destinationMenu) {
    if ((item.dragData.parent.parentId === this.childs[index].parentId) && (item.dragData.parent.id === this.childs[index].id)) {
      return;
    }
    let newOrder = this.getNewOrder(destinationMenu);
    let data = {
      'sourceParentId': 0,
      'sourceID': 0,
      'destinationParentId': 0,
      'destinationID': 0,
      'newOrder': newOrder,
      'type': 'swap',
      'categoryId': item.dragData.parent.categoriesId ? item.dragData.parent.categoriesId : 0
    };
    if (item.dragData.parent.childs.length > 0) {
      item.dragData.parent.childs.forEach(element => {
        let isProhibted = this.isProhibtedHandler(item, index, destinationMenu, element);
        if (isProhibted) {
          this.openSnackBar("Prohibited scope");
        }
        else {
          data.sourceParentId = (item.dragData.parent.parentId) ? item.dragData.parent.parentId : 0;
          data.sourceID = item.dragData.parent.id;
          data.destinationParentId = (this.childs[index].parentId) ? this.childs[index].parentId : 0;
          data.destinationID = this.childs[index].id;
        }
      });
    } else if (this.isProhibtedHandler(item, index, destinationMenu)) {
      if ((item.dragData.parent.parentId === this.childs[index].parentId) && (item.dragData.parent.id === this.childs[index].id)) {
        return;
      }
      this.openSnackBar("Prohibited scope");
      return;
    }
    else {
      // if (index < 0 || index >= this.childs.length || item.dragData.index < 0 || item.dragData.index >= this.childs.length) {
      //   return
      // }
      data.sourceParentId = (item.dragData.parent.parentId) ? item.dragData.parent.parentId : 0;
      data.sourceID = item.dragData.parent.id;
      data.destinationParentId = (this.childs[index].parentId) ? this.childs[index].parentId : 0;
      data.destinationID = this.childs[index].id;
    }
    this.AddSwapChildMenu(data, item);
  }
  drop(event: CdkDragDrop<any[]>) {
    const item = event.item.data; // Get the dragged menu item data
    const index = event.currentIndex; // Get the new index of the dropped item
    const destinationMenu = event.container.data; // Get the destination menu list
  
    if (event.previousContainer === event.container) {
      // Handle reordering within the same container
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  
      // Update the order of items in the backend (if needed)
      // ... your logic to update order in the backend ...
    } else {
      // Handle moving item to a different container
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
  
 
      if (event.container.id === 'parentList') { 
        this.moveMenu(item, index, destinationMenu);
      } else {
        this.moveMenuChild(item, index, destinationMenu);
      }
    }
  }
  AddSwapChildMenu(data, item) {
    if (data.sourceID != 0 && data.destinationID != 0) {
      this.httpClient.post(`/Menus/SwapAndAddMenu`, data).subscribe((res: any) => {
        this.openNotifySuccess('Menu order changed successfuly');
        this.refresh.emit(item.dragData.parent.categoriesId);
      });
    }
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
    });
  }

  toggle(item, event) {
    if (event.target.checked) {
      this.selectedMenus = this.sharedService.addChildMenu(item);
    } else {
      this.selectedMenus = this.sharedService.subtractChildMenu(item);
    }
  }


  exists(item) {
    return this.sharedService.isMenuChecked(item);
  };

  isChecked() {
    this.selectedMenus = this.sharedService.checkSelected();
    return this.selectedMenus.length === this.childs.length;
  };

  ngOnDestroy(): void { }

}
